import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import React from 'react';
import { usePlanCreationPlanPreview } from '../../../../../contexts/create-plan-context/CreatePlanProvider/hooks/use-plan-creation-plan-preview';
import { useVyStepper } from '../../../../../hooks/use-vy-stepper';
import { CreateInvoiceContext } from './create-invoice-context';
import type { CreateInvoiceTab } from './create-invoice-context-types/create-invoice-tab';
import { CREATE_INVOICE_TABS } from './create-invoice-context-types/create-invoice-tab';
import type { InvoiceCreationStep } from './create-invoice-context-types/invoice-creation-step';
import { INVOICE_CREATION_STEPS } from './create-invoice-context-types/invoice-creation-step';

type CreateInvoiceProviderProps = PropsWithChildren<{
  defaultInvoiceCreationStep: InvoiceCreationStep;
  onFinalStep?: () => void;
}>;

export function CreateInvoiceProvider({ children, defaultInvoiceCreationStep, onFinalStep = () => {} }: CreateInvoiceProviderProps) {
  const [currentTab, setCurrentTab] = useState<CreateInvoiceTab>(CREATE_INVOICE_TABS.serviceFees);
  const invoiceCreationStepper = useVyStepper(defaultInvoiceCreationStep, INVOICE_CREATION_STEPS, onFinalStep);
  const planPreview = usePlanCreationPlanPreview();

  return (
    <CreateInvoiceContext.Provider value={{
      invoiceCreationStepper,
      createInvoiceTab: currentTab,
      setCreateInvoiceTab: setCurrentTab,
      planPreview,
    }}
    >
      {children}
    </CreateInvoiceContext.Provider>
  );
}